
<template>
  <v-autocomplete v-if="lstObjectsComputed && lstObjectsComputed.length > 0"
                  v-model="value"
                  :return-object="returnObject"
                  v-model:search="searchText"
                  :loading="loading"
                  :items="lstObjectsComputed"
                  item-title="name"
                  item-value="id"
                  hide-details
                  :disabled="disabled"
                  :custom-filter="customFilter"
                  :label="label"
                  :clearable="clearable"
                  :class="classes"
                  :multiple="multiple"
                  :required="required"
                  :rules="rules"
                  density="compact">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template>
  </v-autocomplete>
  <p v-else-if="loading">Carregando categorias...</p>
  <p v-else>Nenhuma categoria encontrada. Verifique o cadastro e/ou recarregue a página</p>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    classes: String,
    label: String,
    modelValue: Object,
    returnObject: Boolean,
    multiple: Boolean,
    rules: Array,
    types: Array,
    required: Boolean,
    groupId: Number,
    includeDisabled: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      lstObjects: [],
      searchText: null,
      previousSearch: "",
      loading: false,
      timeoutSearchDelay: null,
      enableSearch: false,
    };
  },
  created() {
    const vm = this;

    vm.submitSearch()
  },
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1500);
        vm.loading = true;
      }
    },
    customFilter(item, queryText, itemText) {
      return true
    },
    submitSearch() {
      var vm = this;

      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        
        if (vm.enableSearch) {
          let _prev = (vm.previousSearch || "").toUpperCase();
          let _act = (_searchText || "").toUpperCase();
          if (_act == "" || (_act == " " && _prev == _act)) {
            vm.loading = false;
            return;
          }
        }
        vm.requestingApi = true;
        vm.loading = true;
        return new Promise((resolve, reject) => {
          api.cashFlowCategory
            .listLastLevel(
              {
                group_id: vm.groupId,
                searchText: _searchText,
                itemsPerPage: 30,
                types: vm.types,
                includeDisabled: vm.includeDisabled,
              },
              1
            )
            .then((result) => {
              vm.lstObjects = result || [];
              if (result?.total && result?.total > 30) {
                vm.enableSearch = true;
              }
              resolve(result);
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: 'error',
                  text: err.message
                })
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
  },
  computed: {
    lstObjectsComputed() {
      var vm = this;

      return vm.lstObjects
        .filter(c => vm.searchText == null || c.name.toUpperCase().includes(vm.searchText?.toUpperCase()))
        .map((el) => {
          let _typeText = ''
          let comp = '';
          if (el.type != null) {
            _typeText = vm.$CASH_FLOW_CATEGORY_TYPES_DIC[el.type].label
          }
          if (el.disabled_at) {
            comp = ` (Encerrada em ${vm.$moment.parseZone(el.disabled_at).format('DD/MM/YYYY')})`;
          }
          return {
            type_name: `[${_typeText}] ${el.name}`,
            ...el,
            name: `${el.name}${comp}`
          };
        });
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (value?.id && !value?.name) {
          value = result.find(c => c.id === vm.value.id);
        }
        this.$emit("update:modelValue", value);
      },
    },
  }
};
</script>
